module.exports = __webpack_public_path__ + "static/media/blue-p.4b455c24.svg";